import React from 'react'
import moment from 'moment'
import { DayPicker } from 'react-day-picker'
import 'react-day-picker/style.css'

// Inline single-date calendar (react-day-picker v10), replacing the jQuery
// bootstrap-datetime-picker widget. Same public API as before: `value` is any
// moment-parseable date and `onChange` receives a 'YYYY-MM-DD' string as soon
// as a day is clicked. Wrappers (date_select, date_pill, date_picker_input)
// supply their own popover + Save/Clear/Cancel chrome around this.
const DatePicker = ({ value, onChange }) => {
  const selected = value ? moment(value).toDate() : undefined

  const onSelect = (day) => {
    if (day) {
      onChange(moment(day).format('YYYY-MM-DD'))
    }
  }

  return (
    <DayPicker
      mode="single"
      selected={selected}
      onSelect={onSelect}
      defaultMonth={selected || new Date()}
      showOutsideDays={false}
    />
  )
}

export default DatePicker
